/**
 * 幂等键生成工具
 *
 * 所有需要后端保证幂等的请求（正文生成、目录生成、分析、导出等），
 * 必须使用固定的 key，基于 projectId + 各阶段版本号拼接，
 * 禁止包含 Date.now()、Math.random()、crypto.randomUUID() 等随机成分。
 *
 * 设计原则：
 * - 相同输入（projectId + 版本号 + 操作类型 + 节点ID）→ 相同 key → 后端返回已有任务
 * - 不同输入（版本号变化 = 用户确认了新版本）→ 不同 key → 创建新任务
 * - 与 Vue 版 aibsweb-main 的 idempotency_key 格式保持一致
 */

export type IdempotencySegment = string | number;

/**
 * 生成幂等键：将所有非空片段用 "-" 拼接。
 *
 * 示例：
 *   makeIdempotencyKey('content', 127, 3)              → 'content-127-3'
 *   makeIdempotencyKey('content-single', 127, 3, '1.1')→ 'content-single-127-3-1.1'
 *   makeIdempotencyKey('outline-candidates', 127, 2, 'general') → 'outline-candidates-127-2-general'
 *
 * @param prefix  操作类型前缀（如 'content'、'outline-candidates'、'word-export'）
 * @param projectId 项目 ID
 * @param segments 额外的版本号 / 节点 ID / 风格等固定片段
 */
export function makeIdempotencyKey(
  prefix: string,
  projectId: number,
  ...segments: IdempotencySegment[]
): string {
  const parts: string[] = [prefix, String(projectId)];
  for (const seg of segments) {
    if (seg !== undefined && seg !== null && seg !== '') {
      parts.push(String(seg));
    }
  }
  return parts.join('-');
}
